export const TOKEN_STORAGE_KEY = 'hea_auth_token';
export const USERNAME_STORAGE_KEY = 'hea_auth_username';

export const AUTH_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  HOME: '/',
} as const;

/**
 * Web Lock shared by every call that writes the refresh cookie (refresh, server-side
 * logout): two overlapping refreshes of the same cookie purge every session of the
 * user (HOMCO-1184), and the cookie is shared by all tabs (HOMCO-1269).
 */
export const AUTH_COOKIE_LOCK_NAME = 'hea-auth-cookie';

/** A refresh that does not answer within this delay is abandoned, so it cannot hold the lock. */
export const REFRESH_TIMEOUT_MS = 30_000;

// Pages a user must never be sent back to after signing in.
const NON_RETURNABLE_PATHS: readonly string[] = [AUTH_ROUTES.LOGIN, '/403'];

/**
 * Page to open after signing in: the `from` remembered in the router state when the
 * session ended or a protected route redirected to /login (HOMCO-1269). Only an
 * internal path is accepted — never `//host`, `/\host` or an absolute URL — and never
 * /login or /403; anything else falls back to the home page.
 */
export function getReturnPath(state: unknown): string {
  const from =
    typeof state === 'object' && state !== null ? (state as { from?: unknown }).from : undefined;
  if (typeof from !== 'string' || !from.startsWith('/')) return AUTH_ROUTES.HOME;
  if (from.startsWith('//') || from.startsWith('/\\')) return AUTH_ROUTES.HOME;
  const pathname = from.split(/[?#]/, 1)[0];
  return NON_RETURNABLE_PATHS.includes(pathname) ? AUTH_ROUTES.HOME : from;
}
